var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHomeStation2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 109,
    viewBox: "0 0 105 121",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_386_7824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3292 25.7224C67.1675 25.7224 79.2142 37.7692 79.2142 52.6075V53.4795C79.2142 68.3178 67.1675 80.3646 52.3292 80.3646C37.4909 80.3646 25.4441 68.3178 25.4441 53.4795V52.6075C25.4441 37.7692 37.4909 25.7224 52.3292 25.7224Z",
    fill: "var(--primary-button-color)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4995 12C72.0933 12 88 27.9067 88 47.4995V48.651C88 68.2437 72.0933 84.1505 52.5005 84.1505C32.9067 84.1515 17 68.2437 17 48.651V47.4995C17 27.9067 32.9067 12 52.4995 12Z",
    fill: "var(--primary-button-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8334 66.3332H39.1667C35.5001 66.3332 33.6667 64.4998 33.6667 60.8332V46.1665C33.6667 42.4998 35.5001 40.6665 39.1667 40.6665H48.3334V60.8332C48.3334 64.4998 50.1667 66.3332 53.8334 66.3332Z",
    stroke: "white",
    strokeWidth: 1.65385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5351 33.3333C48.3884 33.8833 48.3334 34.4883 48.3334 35.1666V40.6666H39.1667V36.9999C39.1667 34.9833 40.8167 33.3333 42.8334 33.3333H48.5351Z",
    stroke: "white",
    strokeWidth: 1.65385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6667 40.6665V49.8332",
    stroke: "white",
    strokeWidth: 1.65385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40.6665V49.8332",
    stroke: "white",
    strokeWidth: 1.65385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1667 57.1665H57.5001C56.4917 57.1665 55.6667 57.9915 55.6667 58.9998V66.3332H63.0001V58.9998C63.0001 57.9915 62.1751 57.1665 61.1667 57.1665Z",
    stroke: "white",
    strokeWidth: 1.65385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49.8333V57.1666",
    stroke: "white",
    strokeWidth: 1.65385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3333 60.8334V35.1667C48.3333 31.5001 50.1666 29.6667 53.8333 29.6667H64.8333C68.4999 29.6667 70.3333 31.5001 70.3333 35.1667V60.8334C70.3333 64.5001 68.4999 66.3334 64.8333 66.3334H53.8333C50.1666 66.3334 48.3333 64.5001 48.3333 60.8334Z",
    stroke: "white",
    strokeWidth: 1.65385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_386_7824",
    x: 0.444092,
    y: 0.722412,
    width: 103.77,
    height: 104.642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_386_7824"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeStation2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home-station2.7480406d.svg";
export { ForwardRef as ReactComponent };